// extracted by mini-css-extract-plugin
export default {"accordion-container":"AccordionContainer_accordion-container__R8ttf"};